import { render } from "./goods.vue?vue&type=template&id=6be06361"
import script from "./goods.vue?vue&type=script&lang=js"
export * from "./goods.vue?vue&type=script&lang=js"

import "./goods.vue?vue&type=style&index=0&id=6be06361&lang=scss"

import exportComponent from "/Users/demigodliu/src/packages/cumen/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__